import { useQueryClient } from '@tanstack/react-query';
import useFileTagsQuery from './useFileTagsQuery';
import { queryKeys } from 'hooks/config/queryClient';

export default function useGetTags(caseId = '') {
  const queryClient = useQueryClient();
  const { fullTags, isLoading, refetch } = useFileTagsQuery({
    caseId: caseId ?? '',
    enabled: true,
  });

  const getFileTags = (caseIdArg) => {
    const keyToInvalidate = queryKeys.fileManager.tags(caseIdArg ?? caseId ?? '');
    queryClient.invalidateQueries({ queryKey: keyToInvalidate });
  };

  return {
    getFileTags,
    fullTags,
    isLoading,
  };
}
